import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import './OnboardingFlow.scss';
import Questionnaire from '../../common/Questionnaire';
import Beginning from '../Beginning';
import Finish from '../Finish';
import SideNavStepProgressBar from '../../common/SideNavStepProgressBar/SideNavStepProgressBar';
import OnboardingHeader from '../OnboardingHeader/Index';
import OnboardingCompleted from '../OnboardingCompleted';
import { postRequest } from '../../../requestUtils';
import { analyticsTrack } from '../../../analyticsUtils';

class OnboardingFlowContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      state: 0,
      step: 0,
      questionnaire: Object.values(props.questionnaire),
      updateMenu: false,
      showFinishPage: false,
      uploadingResume: false,
    };

    this.setNextState = this.setNextState.bind(this);
    this.updateQuestionnaire = this.updateQuestionnaire.bind(this);
    this.handleNextStep = this.handleNextStep.bind(this);
    this.handlePreviousStep = this.handlePreviousStep.bind(this);
    this.setPreviousState = this.setPreviousState.bind(this);
    this.handleMenuClick = this.handleMenuClick.bind(this);
    this.handleMenuUpdate = this.handleMenuUpdate.bind(this);
    this.handleShowFinishPage = this.handleShowFinishPage.bind(this);
    this.handleResumeUpload = this.handleResumeUpload.bind(this);
  }

  componentDidMount() {
    const { userId } = this.props;

    analyticsTrack('Consultant Onboarding Started', {
      userId,
    });
  }

  setNextState(clorifyInfo) {
    const { state, questionnaire } = this.state;
    if (questionnaire.length === 1) {
      this.setState({ state: 2 });
    } else {
      if (state === 0) {
        this.setState({ clorifyInfo });
      }
      this.setState({ state: state + 1 });
    }
  }

  setPreviousState() {
    const { state } = this.state;
    this.setState({ state: state - 1 });
  }

  handleShowFinishPage(value) {
    const { userId, finishViewLink } = this.props;

    if (value) {
      analyticsTrack('User Reaches Onboarding Complete Page', {
        location: 'Onboarding Flow',
        userId,
      });
    }

    if (finishViewLink) {
      window.location = finishViewLink;
    } else {
      this.setState({ showFinishPage: value });
    }
  }

  updateQuestionnaire(updatedQuestionnaire) {
    this.setState({ questionnaire: updatedQuestionnaire });
  }

  handleNextStep() {
    const { taggingUrl, csrfToken } = this.props;
    const { step } = this.state;

    if (step === 2) {
      postRequest(taggingUrl, {}, csrfToken);
    }
    this.setState((prevState) => ({ step: prevState.step + 1 }));
  }

  handlePreviousStep() {
    this.setState((prevState) => ({ step: prevState.step - 1 }));
  }

  handleMenuClick(state, step) {
    this.setState({ state, step });
  }

  handleMenuUpdate(value = false) {
    this.setState({ updateMenu: value });
  }

  handleResumeUpload(uploading) {
    this.setState({ uploadingResume: uploading });
  }

  renderQuestionnaires() {
    const {
      name,
      userId,
      questionnaireId,
      questionnaireName,
      questionabledId,
      questionableType,
      csrfToken,
      finishViewLink,
      isOwner,
      onboardType,
      getClaimInfoUrl,
      claimInfoUrl,
      profileUrl,
      profileQuestionnaireId,
    } = this.props;
    const {
      state, questionnaire, step, updateMenu, uploadingResume,
    } = this.state;
    if (state === 0) {
      return (
        <Beginning
          name={name}
          userId={userId}
          questionnaire={questionnaire}
          questionnaireName={questionnaireName}
          questionableId={questionabledId}
          questionableType={questionableType}
          questionnaireQuestionIds={questionnaire[0].map((x) => x.id)}
          csrfToken={csrfToken}
          getClaimInfoUrl={getClaimInfoUrl}
          claimInfoUrl={claimInfoUrl}
          isOwner={isOwner}
          setStateQuestionnaire={this.setNextState}
          updateQuestionnaire={this.updateQuestionnaire}
          finishViewLink={finishViewLink}
          onboardType={onboardType}
          handleNextStep={this.handleNextStep}
          updateMenu={updateMenu}
          handleMenuUpdate={this.handleMenuUpdate}
          handleResumeUpload={this.handleResumeUpload}
          uploadingResume={uploadingResume}
        />
      );
    } if (state === 2 && onboardType === 'lazy_onboard') {
      return (
        <Finish
          claimInfoUrl={claimInfoUrl}
          csrfToken={csrfToken}
          resourceLink={finishViewLink}
          resource="ConsultantProfile"
          onboardType={onboardType}
          finish
        />
      );
    }
    return (
      <Questionnaire
        userId={userId}
        questionnaireId={questionnaireId}
        questionnaireName={questionnaireName}
        questionnaire={questionnaire.slice(1)}
        questionableId={questionabledId}
        questionableType={questionableType}
        csrfToken={csrfToken}
        finishViewLink={finishViewLink}
        isOwner={isOwner}
        onboardType={onboardType}
        page={step === 0 ? step : step - 1}
        name={name}
        suggestedAnswers={this.state.clorifyInfo}
        profileUrl={profileUrl}
        finish={state === 2}
        profileQuestionnaireId={profileQuestionnaireId}
        handlePreviousStep={this.handlePreviousStep}
        handleNextStep={this.handleNextStep}
        setPreviousState={this.setPreviousState}
        updateMenu={updateMenu}
        handleMenuUpdate={this.handleMenuUpdate}
        handleShowFinishPage={this.handleShowFinishPage}
      />
    );
  }

  render() {
    const {
      step, state, updateMenu, showFinishPage, uploadingResume,
    } = this.state;
    const {
      onboardType,
      name,
      finishViewLink,
      csrfToken,
      userId,
      profileUrl,
      claimInfoUrl,
    } = this.props;
    return (
      <Fragment>
        <OnboardingHeader
          onboardType={onboardType}
          name={name}
          finishViewLink={finishViewLink}
          claimInfoUrl={claimInfoUrl}
          profileUrl={profileUrl}
          csrfToken={csrfToken}
          userId={userId}
          step={step}
          state={state}
          updateMenu={updateMenu}
          handleMenuUpdate={this.handleMenuUpdate}
          handleMenuClick={this.handleMenuClick}
          showFinishPage={showFinishPage}
        />
        {showFinishPage
          ? (
            <OnboardingCompleted
              csrfToken={csrfToken}
              profileUrl={profileUrl}
              userId={userId}
              onboardType={onboardType}
            />
          )
          : (
            <div className="onboarding-beginning welcome">
              <div className="profile-faq">
                <div className="sticky-content">
                  <h2>Build your profile</h2>
                  <SideNavStepProgressBar
                    step={step}
                    state={state}
                    userId={userId}
                    updateMenu={updateMenu}
                    uploadingResume={uploadingResume}
                    handleMenuUpdate={this.handleMenuUpdate}
                    handleMenuClick={this.handleMenuClick}
                  />
                </div>
              </div>
              <div className="questionnaire-container">
                {this.renderQuestionnaires()}
                <div className="mobile-footer">
                  <nav className="navbar navbar-default">
                    <div className="container">

                      <div className="navbar-header">
                        <button
                          type="button"
                          className="navbar-toggle collapsed"
                          data-bs-toggle="collapse"
                          data-bs-target="#clora-footer-navbar"
                          aria-expanded="false"
                        >
                          <span className="sr-only">Toggle navigation</span>
                          <span className="icon-bar" />
                          <span className="icon-bar" />
                          <span className="icon-bar" />
                        </button>
                        <span className="navbar-text navbar-brand">
                          ©
                          {' '}
                          {new Date().getFullYear()}
                          {' '}
                          Clora
                        </span>
                      </div>

                      <div className="navbar-collapse collapse" id="clora-footer-navbar">
                        <ul className="nav navbar-nav navbar-right">
                          <li><a href="/privacy-policy">Privacy Policy</a></li>
                        </ul>
                      </div>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          )}
      </Fragment>
    );
  }
}

OnboardingFlowContainer.propTypes = {
  name: PropTypes.string,
  userId: PropTypes.string.isRequired,
  questionnaireId: PropTypes.number.isRequired,
  questionnaireName: PropTypes.string.isRequired,
  questionnaire: PropTypes.shape({}).isRequired,
  questionabledId: PropTypes.number.isRequired,
  questionableType: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  finishViewLink: PropTypes.string,
  isOwner: PropTypes.bool.isRequired,
  onboardType: PropTypes.string,
  getClaimInfoUrl: PropTypes.string.isRequired,
  claimInfoUrl: PropTypes.string.isRequired,
  taggingUrl: PropTypes.string.isRequired,
  profileUrl: PropTypes.string.isRequired,
  profileQuestionnaireId: PropTypes.number.isRequired,
};

OnboardingFlowContainer.defaultProps = {
  name: '',
  finishViewLink: '',
  onboardType: 'onboard',
};

export default OnboardingFlowContainer;
